export const STATE_MA = {label: 'Massachusetts', abbreviation: 'MA', _id: '507f191e810c19729de860ea'};

export const STATE = [
    STATE_MA,
    {label: 'Alabama', abbreviation: 'AL', _id: '507f191e810c19729de860eb'},
    {label: 'Alaska', abbreviation: 'AK', _id: '507f191e810c19729de860ec'},
    {label: 'Arizona', abbreviation: 'AZ', _id: '507f191e810c19729de860ed'},
    {label: 'Arkansas', abbreviation: 'AR', _id: '507f191e810c19729de860ee'},
    {label: 'California', abbreviation: 'CA', _id: '507f191e810c19729de860ef'},
    {label: 'Colorado', abbreviation: 'CO', _id: '507f191e810c19729de860f0'},
    {label: 'Connecticut', abbreviation: 'CT', _id: '507f191e810c19729de860f1'},
    {label: 'Delaware', abbreviation: 'DE', _id: '507f191e810c19729de860f2'},
    {label: 'Florida', abbreviation: 'FL', _id: '507f191e810c19729de860f3'},
    {label: 'Georgia', abbreviation: 'GA', _id: '507f191e810c19729de860f4'},
    {label: 'Hawaii', abbreviation: 'HI', _id: '507f191e810c19729de860f5'},
    {label: 'Idaho', abbreviation: 'ID', _id: '507f191e810c19729de860f6'},
    {label: 'Illinois', abbreviation: 'IL', _id: '507f191e810c19729de860f7'},
    {label: 'Indiana', abbreviation: 'IN', _id: '507f191e810c19729de860f8'},
    {label: 'Iowa', abbreviation: 'IA', _id: '507f191e810c19729de860f9'},
    {label: 'Kansas', abbreviation: 'KS', _id: '507f191e810c19729de860fa'},
    {label: 'Kentucky', abbreviation: 'KY', _id: '507f191e810c19729de860fb'},
    {label: 'Louisiana', abbreviation: 'LA', _id: '507f191e810c19729de860fc'},
    {label: 'Maine', abbreviation: 'ME', _id: '507f191e810c19729de860fd'},
    {label: 'Maryland', abbreviation: 'MD', _id: '507f191e810c19729de860fe'},
    {label: 'Michigan', abbreviation: 'MI', _id: '507f191e810c19729de860ff'},
    {label: 'Minnesota', abbreviation: 'MN', _id: '507f191e810c19729de86100'},
    {label: 'Mississippi', abbreviation: 'MS', _id: '507f191e810c19729de86101'},
    {label: 'Missouri', abbreviation: 'MO', _id: '507f191e810c19729de86102'},
    {label: 'Montana', abbreviation: 'MT', _id: '507f191e810c19729de86103'},
    {label: 'Nebraska', abbreviation: 'NE', _id: '507f191e810c19729de86104'},
    {label: 'Nevada', abbreviation: 'NV', _id: '507f191e810c19729de86105'},
    {label: 'New Hampshire', abbreviation: 'NH', _id: '507f191e810c19729de86106'},
    {label: 'New Jersey', abbreviation: 'NJ', _id: '507f191e810c19729de86107'},
    {label: 'New Mexico', abbreviation: 'NM', _id: '507f191e810c19729de86108'},
    {label: 'New York', abbreviation: 'NY', _id: '507f191e810c19729de86109'},
    {label: 'North Carolina', abbreviation: 'NC', _id: '507f191e810c19729de86110'},
    {label: 'North Dakota', abbreviation: 'ND', _id: '507f191e810c19729de86111'},
    {label: 'Ohio', abbreviation: 'OH', _id: '507f191e810c19729de86112'},
    {label: 'Oklahoma', abbreviation: 'OK', _id: '507f191e810c19729de86113'},
    {label: 'Oregon', abbreviation: 'OR', _id: '507f191e810c19729de86114'},
    {label: 'Pennsylvania', abbreviation: 'PA', _id: '507f191e810c19729de86115'},
    {label: 'Rhode Island', abbreviation: 'RI', _id: '507f191e810c19729de86116'},
    {label: 'South Carolina', abbreviation: 'SC', _id: '507f191e810c19729de86117'},
    {label: 'South Dakota', abbreviation: 'SD', _id: '507f191e810c19729de86118'},
    {label: 'Tennessee', abbreviation: 'TN', _id: '507f191e810c19729de86119'},
    {label: 'Texas', abbreviation: 'TX', _id: '507f191e810c19729de86120'},
    {label: 'Utah', abbreviation: 'UT', _id: '507f191e810c19729de86121'},
    {label: 'Vermont', abbreviation: 'VT', _id: '507f191e810c19729de86122'},
    {label: 'Virginia', abbreviation: 'VA', _id: '507f191e810c19729de86123'},
    {label: 'Washington', abbreviation: 'WA', _id: '507f191e810c19729de86124'},
    {label: 'West Virginia', abbreviation: 'WV', _id: '507f191e810c19729de86125'},
    {label: 'Wisconsin', abbreviation: 'WI', _id: '507f191e810c19729de86126'},
    {label: 'Wyoming', abbreviation: 'WY', _id: '507f191e810c19729de86127'},
];
